var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InputEmbed',{attrs:{"value":_vm.data,"show-embed-code":""},on:{"blur":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }